import { useQuery } from "@tanstack/react-query";
import { getProductsWithNoRecipe } from "../repositories/ProductsWithNoRecipeRepository";

export const useProductsWithNoRecipe = () =>
	useQuery({
		queryKey: ["productsWithNoRecipe"],
		queryFn: ({ signal }) => getProductsWithNoRecipe({ signal }),
		refetchOnWindowFocus: false,
		refetchOnReconnect: false,
	});
